import React, { useRef, useState } from "react";
import AppButton from "../../../../shared/components/generic/button/app-button";
import CardGeneric from "../../../../shared/components/generic/card/card-generic";
import FormGeneric from "../../../../shared/components/generic/form/form-generic";
import InlineAlert from "../../../../shared/components/generic/alert/inline-alert/inline-alert";
import { apuracaoReviewFormConfig } from "../../config/apuracao-review-form-config";
import { showConfirmAlert } from "../../../../shared/components/generic/alert/confirm-alert/confirm-alert";
import { showCommonAlert } from "../../../../shared/components/generic/alert/utils/show-common-alert-utils";

const AssessmentReviewCard = ({
	onApprove,
	onReject,
	loading = false
}) => {
	const [isReviewFormVisible, setIsReviewFormVisible] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);
	const isProcessingRef = useRef(false);

	const isBusy = loading || isProcessing;

	const handleOpenReviewForm = () => {
		if (isBusy) {
			return;
		}

		setIsReviewFormVisible(true);
	};

	const handleCancelReviewForm = () => {
		if (isBusy) {
			return;
		}

		setIsReviewFormVisible(false);
	};

	const handleDecision = async ({
		isApproval,
		action,
		values
	}) => {
		if (
			loading ||
			isProcessingRef.current ||
			typeof action !== "function"
		) {
			return;
		}

		isProcessingRef.current = true;
		setIsProcessing(true);

		try {
			const confirmation = await showConfirmAlert({
				title: isApproval
					? "Confirmar aprovação"
					: "Confirmar reprovação",
				description: isApproval
					? "Deseja aprovar as apurações deste ciclo?"
					: "Deseja reprovar as apurações deste ciclo?",
				confirmLabel: isApproval ? "Aprovar" : "Reprovar",
				cancelLabel: "Cancelar"
			});

			const isConfirmed = confirmation && (
				confirmation.isConfirmed === true ||
				confirmation.value === true
			);

			if (!isConfirmed) {
				return;
			}

			const result = await action(values);

			if (!result || !result.ok) {
				await showCommonAlert({
					title: "Erro",
					message: result && result.error,
					fallbackMessage: "Não foi possível registrar a decisão.",
					icon: "error"
				});

				return result;
			}

			if (!isApproval) {
				setIsReviewFormVisible(false);
			}

			await showCommonAlert({
				title: "Sucesso",
				message: isApproval
					? "Aprovação registrada com sucesso."
					: "Reprovação registrada com sucesso.",
				icon: "success"
			});

            window.location.reload();
            
			return result;
		} catch (requestError) {
			await showCommonAlert({
				title: "Erro",
				message: requestError.message,
				fallbackMessage: "Não foi possível registrar a decisão.",
				icon: "error"
			});
		} finally {
			isProcessingRef.current = false;
			setIsProcessing(false);
		}
	};

	const handleApproveAssessment = () => {
		return handleDecision({
			isApproval: true,
			action: onApprove
		});
	};

	const handleSubmitReviewForm = values => {
		return handleDecision({
			isApproval: false,
			action: onReject,
			values
		});
	};

	return (
		<CardGeneric
			compact
			className={[
				"apuracao-review-card",
				isReviewFormVisible
					? "apuracao-review-card--with-form"
					: ""
			].filter(Boolean).join(" ")}
			bodyClassName="apuracao-review-card__body"
		>
			<div className="apuracao-review-card__top">
				<InlineAlert
					variant="warning"
					className="apuracao-review-card__warning"
					message="Atenção: Ao salvar, o sistema enviará e-mail automaticamente às equipes de BI, Instrument e TI."
				/>

				<div className="apuracao-review-card__actions">
					<AppButton
						type="button"
						className="apuracao-review-card__button apuracao-review-card__button--review"
						onClick={handleOpenReviewForm}
						disabled={
							isBusy ||
							isReviewFormVisible ||
							typeof onReject !== "function"
						}
					>
						Reprovar
					</AppButton>

					<AppButton
						type="button"
						className="apuracao-review-card__button apuracao-review-card__button--approve"
						onClick={handleApproveAssessment}
						disabled={
							isBusy ||
							isReviewFormVisible ||
							typeof onApprove !== "function"
						}
					>
						Aprovar
					</AppButton>
				</div>
			</div>

			{isReviewFormVisible && (
				<div className="apuracao-review-form">
					<div className="apuracao-review-form__content">
						<FormGeneric
							formId="apuracao-review-form"
							formFields={apuracaoReviewFormConfig}
							onSubmit={handleSubmitReviewForm}
						/>

						<div className="apuracao-review-form__actions">
							<AppButton
								type="button"
								className="apuracao-review-form__button apuracao-review-form__button--cancel"
								onClick={handleCancelReviewForm}
								disabled={isBusy}
							>
								Cancelar
							</AppButton>

							<AppButton
								type="submit"
								form="apuracao-review-form"
								className="apuracao-review-form__button apuracao-review-form__button--save"
								disabled={
									isBusy ||
									typeof onReject !== "function"
								}
							>
								{isBusy ? "Enviando..." : "Salvar"}
							</AppButton>
						</div>
					</div>
				</div>
			)}
		</CardGeneric>
	);
};

export default AssessmentReviewCard;